<template>
    <div class="grid-x underline-radio">
        <div class="cell">
            <div class="grid-x">
                <div :class="['cell', 'auto', 'option', 'text-center', {selected: isSelected(optionValue)}, {disabled: isDisabled(optionValue)}]" v-for="([optionName, optionValue], i) in options" :key="i" @click="selectOption(optionValue)">
                    <p :class="['label', {'semi-bold': isSelected(optionValue)}]">{{ optionName }}</p>
                </div>
            </div>
        </div>
        <div class="cell underline">
            <span class="underline-element" :style="underlinePosition"></span>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UnderlineRadio extends Vue
{
    @Prop({type: Array}) readonly options!: [string, string][];
    @Prop({type: Array}) readonly disabledOptions!: [string];
    @Prop({type: String}) readonly selected!: string;


    selectOption(optionValue: string) {
        if (!this.isDisabled(optionValue)) {
            this.$emit('select', optionValue);
        }
    }

    get isSelected() {
        return (optionValue: string) => this.selected === optionValue;
    }

    get isDisabled() {
        return (optionValue: string) => this.disabledOptions.includes(optionValue);
    }

    get underlinePosition() {
        const size = Math.round(100 / this.options.length);
        const selectedIndex = this.options.findIndex(([label, value]) => {
            return value === this.selected;
        });
        return {
            width: size + '%',
            left: size * selectedIndex + '%'
        };
    }
}

</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.underline-radio {
    width: 100%;
    margin-bottom: 10px;

    .underline {
        height: 3px;
        width: 100%;
        position: relative;

        &:before {
            content: '';
            position: relative;
            display: block;
            top: 3px;
            width: 100%;
            height: 1px;
            background: var(--underline-radio-track-color);
        }

        .underline-element {
            position: absolute;
            height: 100%;
            border-radius: var(--underline-radio-radius);
            background-color: var(--underline-radio-line-color);
            transition: left ease 0.3s;
        }
    }

    .option {
        cursor: pointer;

        &.selected {
            .label {
                color: var(--underline-radio-label-selected-color);
            }
        }
        &.disabled {
            .label {
                color: var(--customizer-option-disabled-color);
            }
        }
        .label {
            color: var(--underline-radio-label-color);
            transition: color ease 0.3s;
            margin: 5px 0;
        }
    }
}

</style>